import { z } from 'zod';
import { CalendarDay } from 'further-ui/utils';

export const schema = z.object({
  noticeDate: z
    .instanceof(CalendarDay, { message: 'Select a notice date.' })
    .nullish(),
  mainContactEmails: z.string(),
  lcyRecipientAccountId: z.string().nullish(),
  capitalActionName: z.string(),
  capitalActionDueDate: z.instanceof(CalendarDay).nullish(),
});

export const strictSchema = z.object({
  noticeDate: z.instanceof(CalendarDay, { message: 'Select a notice date.' }),
  mainContactEmails: z.string().min(1, 'Enter contact emails.'),
  lcyRecipientAccountId: z
    .string({ message: 'Select a recipient account.' })
    .min(1, 'Select a recipient account.'),
  capitalActionName: z.string().min(1, 'Enter a capital action name.'),
  capitalActionDueDate: z.instanceof(CalendarDay, {
    message: 'Select a due date.',
  }),
});

export type FormValues = z.infer<typeof schema>;
